import { SystemStyleObject, Theme } from "@mui/system";
import type { ActivityCellStyle } from "../types/npi-dashboard.types";
import { NpiActivityStatus } from "../types/npi-project.types";
import { NpiChecklistItemStatus } from "../../../../../models/npi/npi-checklist";

export const PROJECT_COLUMN_WIDTH = 192;
export const PHASE_COLUMN_WIDTH = 150;
export const STEP_COLUMN_WIDTH = 180;
export const GRID_GAP = 8;
export const GRID_PADDING = 12;
export const CELL_BORDER_RADIUS = 10;
export const GRID_BORDER_WIDTH = 1;
export const LATE_THRESHOLD_DAYS = 3;

export const DEFAULT_ACTIVITY_STYLE: ActivityCellStyle = {
  background: "#F1F3F5",
  border: "#E2E8F0",
  color: "#1E293B",
};
export const RECENTLY_DELAYED_STYLE: ActivityCellStyle = {
  background: "#FED7AA",
  border: "#F59E0B",
  color: "#78350F",
};
export const SEVERELY_DELAYED_STYLE: ActivityCellStyle = {
  background: "#FECACA",
  border: "#F87171",
  color: "#B91C1C",
};

export const labelCellSx: SystemStyleObject<Theme> = {
  display: "flex",
  alignItems: "center",
  p: 1.5,
  borderRadius: `${CELL_BORDER_RADIUS}px`,
  backgroundColor: "#F1F5F9",
  fontSize: "15px",
  color: "#1E293B",
  boxSizing: "border-box",
};

export const projectHeaderSx: SystemStyleObject<Theme> = {
  p: 1.25,
  width: "auto",
  cursor: "pointer",
  borderRadius: "10px",
  border: "1px solid #E2E8F0",
  backgroundColor: "#F8FAFC",
  boxSizing: "border-box",
  "&:hover": { borderColor: "#003FFB", backgroundColor: "#F5F8FF" },
};

export const activityCellSx: SystemStyleObject<Theme> = {
  height: 65,
  width: "auto",
  borderRadius: "10px",
  boxSizing: "border-box",
  px: 1.5,
};

export type StatusStyle = { color: string; background: string; border: string };

export const STATUS_STYLES: Record<NpiActivityStatus, StatusStyle> = {
    concluido: { color: "#0D4A22", background: "#CEF4D2", border: "1px solid #60b168" },
    em_andamento: { color: "#2A62AD", background: "#DBEAFE", border: "1px solid #658ab8" },
    atrasado: { color: "#BF403C", background: "#FFB6B4", border: "1px solid #e26c68" },
    nao_iniciada: { color: "#616161", background: "#EEEEEE", border: "1px solid #a0a0a0" },
    nao_sera_executada: { color: "#7C7C7C", background: "#E8E8E8", border: "1px dashed #a0a0a0" },
};

export const ATTENTION_STYLE: StatusStyle = { color: "#C78100", background: "#FFD993", border: "1px solid #F3AF31" };

export const CRITICAL_DELAY_DAYS = 4;

export type LegendItem = { color: string; label: string };

export const CHECKLIST_PHASE_LEGEND_ITEMS: LegendItem[] = [
  { color: "#8B5CF6", label: "Plan Phase" },
  { color: "#2563EB", label: "Development Phase" },
  { color: "#F59E0B", label: "Start Up Phase" },
  { color: "#16A34A", label: "Launch Phase" },
];

export const CHECKLIST_NO_PHASE_COLOR = "#CBD5E1";

export const getChecklistPhaseColor = (index: number) =>
  CHECKLIST_PHASE_LEGEND_ITEMS[index]?.color ?? CHECKLIST_NO_PHASE_COLOR;

export const CHECKLIST_ITEM_STATUS_STYLES: Record<NpiChecklistItemStatus, { label: string; color: string; background: string }> = {
  [NpiChecklistItemStatus.COMPLETED]: { label: "checklist_complete", color: "#15803D", background: "#DCFCE7" },
  [NpiChecklistItemStatus.ON_GOING]: { label: "checklist_on_going", color: "#B45309", background: "#FEF3C7" },
  [NpiChecklistItemStatus.AT_RISK]: { label: "checklist_at_risk", color: "#FFFFFF", background: "#DC2626" },
  [NpiChecklistItemStatus.NOT_APPLICABLE]: { label: "checklist_not_applicable", color: "#64748B", background: "#F1F5F9" },
};
